import { useCallback } from 'react';
import { DATE_FORMATS_TYPES, useI18n } from '@namespace/i18n';

interface DateColumnProps {
  dt?: string;
  dtDone?: string;
}

export const DateColumn = ({ dt, dtDone }: DateColumnProps) => {
  const { f } = useI18n();
  const formatDate = useCallback(
    (date: string, format: string) =>
      f.getDateTime({ date, fromUTC: true }).toFormat(format),
    [f]
  );
  let date = '';
  if (dt) {
    date += formatDate(dt, DATE_FORMATS_TYPES.DEPOSIT_HISTORY_DATE_TIME);
  }
  if (dtDone) {
    date += ' - ';
    date += formatDate(dtDone, DATE_FORMATS_TYPES.DEPOSIT_HISTORY_DATE_TIME);
  }
  return <>{date}</>;
};
